export default {"src":"/_next/static/media/clip.9fbfbe4a.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};